import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IGetLanguages, IItemForGetShortInfo, TLanguageIDs } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getLanguages } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';

interface ITranslationsMultipleSelect {
	setIDsLanguages: (value: TLanguageIDs[]) => void;
	setFetchedLanguages: (value: IItemForGetShortInfo[]) => void;
}

const TranslationsMultipleSelect: React.FC<ITranslationsMultipleSelect> = ({
	setIDsLanguages,
	setFetchedLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetLanguages, void>(getLanguages);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	useEffect(() => {
		response && setFetchedLanguages(response.data.languages);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectOneLanguage') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return response?.data.languages.map((el) => ({ id: el.id, name: tForm(el.name) })) || [];
	}, [response, tForm]);

	return (
		<FormSelect
			testId="TranslationsMultipleSelect"
			name="IDsSelectedLanguages"
			label="translationsLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			disabled={loading}
			onRefetch={refetch}
			onChange={setIDsLanguages}
			validationRules={validationRules}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(TranslationsMultipleSelect);
